import Vue from 'vue'
import BootsrapVue from 'bootstrap-vue';
import moment from 'moment';
import VueCompositionAPI from '@vue/composition-api'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import VueApexCharts from 'vue-apexcharts';

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// map plugin
import 'leaflet/dist/leaflet.css';

// import assets styles
require('@/assets/scss/style.scss')

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// BSV Plugin Registration
Vue.use(BootsrapVue)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('formatDate', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY');
});

Vue.filter('formatDateTime', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY HH:mm');
});

Vue.filter('capEachWord', value => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
});

Vue.filter('boolToYes', value => (value ? 'Yes' : 'No'));

Vue.filter('formatDateAge', value => {
  if (!value) return '';
  return moment(new Date()).diff(value, 'years');
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
